"use strict";


Shopify.theme.jsFeaturedBlog = {
    init: function init($section) {
        // Add settings from schema to current object
        Shopify.theme.jsFeaturedBlog = $.extend(this, Shopify.theme.getSectionData($section));

        this.createSlider();
    },
    createSlider: function createSlider() {
        if($(window).width() < 799) {
            var mySwiper = new Swiper('.featured-blog-gallery.swiper-container.image-slider', {
                // Optional parameters
                loop: true,
                slidesPerView: 1,
                slidesPerGroup: 1,
                grabCursor: true,
                spaceBetween: 15,
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button.next',
                    prevEl: '.swiper-button.previous',
                }
            });

            var mySwiperSecond = new Swiper('.featured-blog-gallery.swiper-container.text-slider', {
                // Optional parameters
                loop: true,
                slidesPerView: 1,
                slidesPerGroup: 1,
                grabCursor: true,
                effect: "fade",
                fadeEffect: { crossFade: true }

            });
            mySwiper.controller.control = mySwiperSecond;
            mySwiperSecond.controller.control = mySwiper;
        }

        // var blogSlider = $('.featured-blog-gallery');
        // var slideData = {
        //     blocks_per_slide: 1,
        //     blocks_limit: this.blocks_limit,
        //     cellAlign: "left",
        //     wrapAround: true
        // };
        // if($(window).width() < 799) {
        //     $(blogSlider).flickity({
        //         lazyLoad: 2,
        //         freeScroll: false,
        //         imagesLoaded: true,
        //         draggable: true,
        //         cellAlign: 'center',
        //         wrapAround: slideData.wrapAround,
        //         pageDots: false,
        //         contain: true,
        //         prevNextButtons: false,
        //         initialIndex: 0,
        //         arrowShape: arrowShape,
        //         on: {
        //             ready: function ready() {
        //                 // Reset layout to avoid collapsing issues
        //                 setTimeout(function () {
        //                     $(blogSlider).flickity('resize');
        //                 }, 500);
        //             }
        //         }
        //     });
        // }
    },
    unload: function unload($section) {
        // var $slider = $section.find('.flickity-enabled');
        // $slider.flickity('destroy');
    }
};